import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const RiskAssessment = lazy(() => import('./RiskAssessments'))
const AssessmentDetails = lazy(() => import('./AssessmentDetails'))

const RiskAssessmentRoutes = [
    {
        path: '/risk_assessment',
        component: RiskAssessment,
        auth: authRoleAccess.risk_assessment,
    },
    {
        path: '/risk_assessments/:id',
        component: AssessmentDetails,
        auth: authRoleAccess.risk_assessment,
    },

]

export default RiskAssessmentRoutes 